<template>
  <v-container fluid v-resize="onResize">
    <v-sheet outlined elevation="0" rounded>
      <v-card flat class="mx-0 px-1 py-1" elevation="0">
        <v-toolbar height="8" elevation="0">
          <v-spacer></v-spacer>
          <v-icon
              v-if="!readonly"
              color="primary"
              @click.stop="onOpenDialog()"
              class="mr-n3"
          >mdi-dots-horizontal</v-icon>
        </v-toolbar>
        <TipTapEditor v-model="localContentView" :show-tool-bar="false" :readonly="true"
                      class="px-0 py-0"></TipTapEditor>
      </v-card>
    </v-sheet>

    <v-dialog
        v-model="dialog"
        persistent
    >
      <v-card>
        <TipTapEditor v-model="localContentEdit" :show-tool-bar="true" :height="windowSize.y * 0.9 - 200">
          <template v-slot:bar.end>
            <slot name="bar.end"></slot>
          </template>
        </TipTapEditor>
        <v-card-actions height="36">
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="onCancelDialog()"
          >
            Cancel
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="onSaveDialog()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TipTapEditor from "@/components/TipTap/TipTapEditor";

export default {
  name: 'TipTapModalEditor',
  components: {
    TipTapEditor,
  },
  props: {
    value: {type: Object, default: null,},
    readonly: {type: [Boolean], default: false},
  },

  computed: {},

  watch: {
    value: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue, JSON.stringify(oldValue))
        this.localContentView = JSON.parse(JSON.stringify(newValue))
      },
      deep: true
    },
  },

  methods: {

    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },

    onOpenDialog() {
      this.localContentEdit = JSON.parse(JSON.stringify(this.value))
      this.localContentView = JSON.parse(JSON.stringify(this.value))
      this.dialog = true
    },

    onCancelDialog() {
      this.dialog = false
    },

    onSaveDialog() {
      // console.log('onSaveDialog', JSON.stringify(this.localContentEdit))
      this.localContentView = JSON.parse(JSON.stringify(this.localContentEdit))
      this.$emit('input', JSON.parse(JSON.stringify(this.localContentEdit)))
      this.dialog = false
    },
  },

  mounted() {
    this.localContentEdit = JSON.parse(JSON.stringify(this.value))
    this.localContentView = JSON.parse(JSON.stringify(this.value))
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      dialog: false,
      localContentEdit: null,
      localContentView: null,
    };
  },
};
</script>
<style>
</style>